import React from 'react'

export default class SpinningControl extends React.Component {
    render() {
        return <div id="SpinningControl"/>
    }
}